export default __webpack_public_path__ + "images/0x1f32b1c2345538c0c6f582fcb022739c4a194ebb.png";